// @flow

export type ContractSummary = {
  defaultCompanyNameOnCard: string
}

const buildContractSummary = (defaultCompanyNameOnCard: string = ''): ContractSummary => {
  return {
    defaultCompanyNameOnCard
  }
}

export {
  buildContractSummary
}



// WEBPACK FOOTER //
// ./src/types/contract-summary.js